import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import { toast } from "react-toastify";
import useAxios from "../../../../Utils/useAxios";
import {
  userRoleAxiosCreate,
  userRoleAxiosUpdate,
} from "../../../../Utils/axiosFunctions";
import { toastSuccess } from "../../../../Utils/toastFunctions";
import {
  berhasilMembuatItemMsg,
  berhasilMengeditItemMsg,
} from "../../../../Constant/Message";
import { InputField, SelectionField } from "../../../../CommonElements";
toast.configure();

const UserRoleForm = ({ resetState, toggle, ur, unitkerja, setUnitkerja }) => {
  const [state, setUrState] = useState({
    pk: "",
    username: "",
    role: "",
    id_unit_kerja: "",
  });

  useEffect(() => {
    if (ur) {
      const { pk, username, role, id_unit_kerja } = ur;
      setUrState({
        pk: pk,
        username: username,
        role: role,
        id_unit_kerja: id_unit_kerja,
      });
    }
  }, [ur]);

  const axiosInstance = useAxios();

  const createUserRole = (e) => {
    e.preventDefault();
    userRoleAxiosCreate(axiosInstance, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMembuatItemMsg("user role"));
    });
  };

  const editUserRole = (e) => {
    e.preventDefault();
    userRoleAxiosUpdate(axiosInstance, state.pk, state).then(() => {
      resetState();
      toggle();
      toastSuccess(berhasilMengeditItemMsg("user role kerja"));
    });
  };

  return (
    <Form onSubmit={ur ? (e) => editUserRole(e) : (e) => createUserRole(e)}>
      <InputField
        state={state}
        label={"Username"}
        name={"username"}
        onChange={(e) => {
          setUrState((prev) => ({ ...prev, username: e.target.value }));
        }}
      />
      <InputField
        state={state}
        label={"Role"}
        name={"role"}
        onChange={(e) => {
          setUrState((prev) => ({ ...prev, role: e.target.value }));
        }}
      />
      <SelectionField
        state={state}
        label={"DPSJ"}
        name={"id_unit_kerja"}
        placeholder={"-- select unit --"}
        options={unitkerja}
        optionsName={"nama_unit_kerja"}
        onChange={(e) => {
          setUrState((prev) => ({
            ...prev,
            id_unit_kerja: e.target.value,
          }));
        }}
      />

      <Button color="primary">Simpan</Button>
    </Form>
  );
};

export default UserRoleForm;
